import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import Button from "@components/Button/Button";
import { ActionType } from "@components/Button/utils/types";
import IconImg from "@components/Icon/IconImg";
import { IconTypeEnum } from "@components/Icon/utils/types";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { ArticleAllToolPopoverProps } from "@features/toolbar/ArticleToolbar/utils/types";
import { cn } from "@util/helpers";

export default function ArticleAppBannerButton({
  handleOpenModal,
  text,
  icon = IconTypeEnum.playLine,
  className,
  testId,
  trackingObject,
  isAlternative,
  isPremium,
  isPodcastArticleToolbar,
  articleTitle,
}: ArticleAllToolPopoverProps): React.ReactElement {
  const { isSubscriber } = useUserInfo();

  const [isAppBannerButtonVisible, setIsAppBannerButtonVisible] =
    useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    if (isSubscriber && isPremium && isAlternative) {
      setIsAppBannerButtonVisible(false);
    }
  }, [isSubscriber, isPremium, isAlternative]);

  const sendDataToGTM = useSendDataToGTM();

  const handleOnClick = () => {
    if (handleOpenModal) handleOpenModal();
    if (typeof window === "undefined" || !trackingObject) return;

    const eventLabel = isPodcastArticleToolbar
      ? articleTitle
      : trackingObject.eventLabel;

    sendDataToGTM({
      ...trackingObject,
      eventLabel: eventLabel || pathname,
    });
  };

  if (!isAppBannerButtonVisible) return <></>;

  return (
    <Button
      actionType={ActionType.actionButton}
      className={cn("gap-1", { "aspect-square px-0": !text }, className, {
        "!hidden": isPodcastArticleToolbar && icon === IconTypeEnum.playLine,
      })}
      onClick={handleOnClick}
      testId={testId}
    >
      <IconImg icon={icon} iconSize={24} imgAlt="play icon" />

      {text ? <p>{text}</p> : null}
    </Button>
  );
}
